import React, { Component } from 'react';
import {  Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import sequenceMetadata from 'decentralized/sequences/SequenceMetadata.js';

class TaggerComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            text: '',
        }
    }

    onInputType(text) {
        this.setState({text: text});
    }

    async onTag() {
        await sequenceMetadata.tagSequence(this.props.sequence.id, this.state.text);
        this.setState({text: ''});
    }

    render() {
        return (
            <div className="track-tagger">
              <InputGroup>
                <Input
                  onChange={(event) => this.onInputType(event.target.value)}
                  value={this.state.text}
                  placeholder={'Type tag'} className="sequence-tag-input"/>
                  <InputGroupAddon addonType="append">
                    <Button onClick={() => this.onTag()} color="secondary">Tag</Button>
                  </InputGroupAddon>
              </InputGroup>
            </div>
        );
    }
}

export default TaggerComponent;
